import React, { useEffect, useState } from 'react'
import { TSchedule, scheduleType, schedules } from '../../shared/types/schedule.type'
import { ScheduleType } from '../../enums/schedules.enums'
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Stack,
    TextField,
    Tooltip,
    Typography,
    useTheme
} from '@mui/material'
import { t } from 'i18next'
import { weekDays } from '../../enums/days.enums'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { isEmpty, orderBy, sortBy, toNumber } from 'lodash'
import { Delete } from '@mui/icons-material'
import timezones from 'timezones-list';
import { TUser } from '../../shared/types/user.type'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { RepportType } from "../../pages/settings/notifications";
import { Icon } from '@iconify/react'

dayjs.extend(utc)
dayjs.extend(timezone)

const initialObject: Partial<schedules> = {
    day_of_week: weekDays.map(e => e.value),
    hour: 12,
    minute: 0,
    type: 'FIXED_TIME',
    timezone: dayjs.tz.guess()

}

type SchedulesProps = {
    schedules: Partial<schedules>[]
    onScheduleChange: (values: Partial<schedules>[]) => void,
    repportType: RepportType,
    lastXHours?: number,
    setLastXHours: (value: number) => void

}

function Schedules({ repportType, schedules, onScheduleChange, lastXHours, setLastXHours }: SchedulesProps) {
    const [currentType, setCurrentType] = useState<scheduleType>('FIXED_TIME')
    const [isEditing, setIsEditing] = useState(false);
    const user = useSelector<RootState>(state => state.user?.user) as TUser
    const theme = useTheme();


    console.log({schedules});
    

    useEffect(() => {
        if (isEmpty(schedules)) {
            addNewSchedule(currentType)
        } else {
            let type = schedules[0].type
            if (type) setCurrentType(type)
        }
    }, [currentType, schedules])

    console.log({ currentType, schedules });


    //fns
    const addNewSchedule = (type: scheduleType) => {

        var newSchedule = {
            ...initialObject, type, timezone: user?.timezone ?? dayjs.tz.guess(), ...(currentType === 'LAST_X_HOURS' ? { count_hours_before: lastXHours } : {})
        };
        if (type == "LAST_WEEK") {
            newSchedule.day_of_week = 7;
            newSchedule.hour = 10;
            newSchedule.minute = 30;
        }
        let schedule = [...schedules, newSchedule]


        onScheduleChange(schedule)
    }
    const formatNumber = (num: number) => {
        if (String(num).length === 2) {
            return num
        } else {
            return String(num).padStart(2, '0')
        }
    }

    const updateState = (index: number, key: keyof schedules, newValue: any) => {
        let find = schedules[index]
        let _schedules = [...schedules]
        if (find) {
            _schedules[index] = { ...find, [key]: newValue }
            onScheduleChange(_schedules)
        }
    }

    const deleteLine = (i: number) => {
        let _schedules = [...schedules]
        _schedules.splice(i, 1)
        onScheduleChange(_schedules)

    }

    const timeArray = () => {
        let i: number[] = [0]
        let max = 45
        let step = 15
        while (i[i.length - 1] < max) {

            i.push(i[i.length - 1] + step)
        }
        return i
    }

    const isChecked = (schedule: Partial<schedules>) => {
        if (typeof schedule.day_of_week === 'number') {
            return false
        } else {
            return schedule.day_of_week?.length === weekDays.length
        }
    }

    const isTriggerMoreShown = () => {
        if (currentType === 'FIXED_TIME') return false
        if (currentType === 'LAST_WEEK') return true; // do not allow to configure more triggers if last week is selected; one per week is enough

        if (isEmpty(schedules)) return false

        return schedules.some(e => {
            if (typeof e.day_of_week !== 'number') {
                return e.day_of_week?.length === weekDays.length
            }

        })

    }

    const handleBlur = () => {
        setIsEditing(false);
    };

    const formattedScheduleType = repportType === "GALLOP_REPPORT" ? ScheduleType.filter((type) => !['SYNCHRONISED_LAST_HOUR', 'LAST_X_HOURS'].includes(type.value)) : ScheduleType

    //
    return (

        <Box p={3} display={'flex'} flexDirection={'column'}>
            <Typography variant='subtitle2'>{t('configuration:triggers')}</Typography>

            {/* List to select Schedule Type */}

            <FormControl size="small">
                <RadioGroup
                    value={currentType}
                    onChange={(_, value) => {
                        const typeValue = value as scheduleType;
                        setCurrentType(typeValue);
                        onScheduleChange(schedules.filter((s) => s?.type === value));
                    }}
                >
                    {formattedScheduleType.map((type) => {
                        if (repportType === 'TRAINING_REPORT' && type.value === "LAST_X_HOURS") {
                            return (
                                <FormControlLabel
                                    key={type.value}
                                    value={type.value}
                                    control={<Radio size="small" />}
                                    label={
                                        <Typography variant="body2" style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                            {t('notification:schedule:lastHour_1')}{" "}
                                            {isEditing ? (
                                                <TextField
                                                    size="small"
                                                    type="number"
                                                    variant='standard'
                                                    value={lastXHours}

                                                    onChange={(e) =>
                                                        setLastXHours(Number(e.target.value))
                                                    }
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            handleBlur(); // exit edit mode
                                                        }
                                                    }}
                                                    onBlur={handleBlur}
                                                    autoFocus
                                                    sx={{
                                                        width: `${String(lastXHours).length * 10 + 20}px`, // auto-fit to digits
                                                        mx: 0.5,
                                                        fontSize: "0.875rem !important",   // match Typography body2
                                                        lineHeight: 1.43,       // match body2 line height
                                                        borderRadius: 1,
                                                        bgcolor: theme.palette.action.hover,
                                                        overflow: 'hidden',
                                                        py: 0,                  // no vertical padding
                                                        "& input": {
                                                            textAlign: "center",
                                                            padding: 0,           // remove default input padding
                                                        },
                                                    }}
                                                />
                                            ) : (
                                                <Box
                                                    component="span"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        e.preventDefault()
                                                        setIsEditing(true)
                                                    }}
                                                    sx={{
                                                        px: 1,
                                                        py: 0.25,
                                                        borderRadius: 1,
                                                        bgcolor: theme.palette.action.hover,
                                                        color: theme.palette.text.primary,
                                                        cursor: "pointer",
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: .5,
                                                        transition: "0.2s",
                                                        mx: .5,
                                                        "&:hover": {
                                                            bgcolor: "var(--active)",   // lighter gray on hover
                                                        },
                                                    }}
                                                >
                                                    {lastXHours} <Icon icon={'mdi:timer-edit-outline'} />
                                                </Box>
                                            )}{" "}
                                            {t('notification:schedule:lastHour_2')}
                                        </Typography>
                                    }
                                />
                            );
                        }

                        return (
                            <FormControlLabel
                                key={type.value}
                                value={type.value}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">{t(type.key)}</Typography>}
                            />
                        );
                    })}
                </RadioGroup>
            </FormControl>

            <Stack direction={'column'} spacing={2} mt={2}>
                {schedules.map((schedule, i) => (
                    <>
                        <Box key={i} justifyContent={'space-between'} display={'flex'} alignItems={'center'}
                            flexWrap={'wrap'} gap={1}>


                            <Box display={'flex'} gap={1} flex={2}>
                                <FormControl size='small' sx={{ flex: 1 }}>
                                    <InputLabel
                                        id="demo-simple-select-label">{t('settings.downloadingDays.unit')}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        multiple={schedule.type !== 'LAST_WEEK'}
                                        value={schedule.day_of_week}
                                        onChange={(e) => {
                                            updateState(i, 'day_of_week', e.target.value)
                                        }}
                                        label={t('settings.downloadingDays.unit')}
                                    >

                                        {weekDays.map((item) =>
                                            <MenuItem value={item.value}>{t(item.key)}</MenuItem>
                                        )}
                                    </Select>


                                </FormControl>
                                {
                                    (schedule.type !== "SYNCHRONISED_LAST_HOUR") &&
                                    <>
                                        <FormControl size='small' sx={{ flex: 1 }}>
                                            <InputLabel
                                                id="demo-simple-select-label">{t('notification:field:hour')}</InputLabel>
                                            <Select

                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"

                                                value={schedule.hour}
                                                onChange={(e) => updateState(i, 'hour', toNumber(e.target.value))}

                                                label={t('notification:field:hour')}>

                                                {[...Array(24)].map((item, i) =>
                                                    <MenuItem key={i}
                                                        value={i + 1}>{i === 23 ? '00' : formatNumber(i + 1)}</MenuItem>
                                                )}
                                            </Select>


                                        </FormControl>

                                        <FormControl size='small' sx={{ flex: 1 }}>
                                            <InputLabel
                                                id="demo-simple-select-label">{t('notification:field:minutes')}</InputLabel>
                                            <Select

                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"

                                                value={schedule.minute}
                                                onChange={(e) => updateState(i, 'minute', toNumber(e.target.value))}
                                                label={t('notification:field:minutes')}>

                                                {timeArray().map((item, i) =>
                                                    <MenuItem key={i} value={item}>{formatNumber(item)}</MenuItem>
                                                )}
                                            </Select>


                                        </FormControl>

                                    </>
                                }
                                <FormControl size='small' sx={{ flex: 2 }}>
                                    <Autocomplete
                                        size='small'
                                        disablePortal
                                        id="combo-box-demo"
                                        value={timezones.find(e => e.tzCode === schedule?.timezone) ?? undefined}
                                        options={sortBy(timezones, (item) => item.tzCode)}
                                        getOptionKey={tz => tz.tzCode}
                                        onChange={(_, value) => updateState(i, 'timezone', value?.tzCode)}
                                        getOptionLabel={tz => tz.tzCode}
                                        renderInput={(params) => <TextField {...params}
                                            label={t('notification:field:timezone')} />}
                                    />
                                </FormControl>


                                <Tooltip title={t('button:delete')} arrow>
                                    <IconButton onClick={() => deleteLine(i)} size='small' color='error'>
                                        <Delete></Delete>
                                    </IconButton>
                                </Tooltip>

                            </Box>

                        </Box>
                        {(schedule.type === 'FIXED_TIME' || schedule.type === 'SYNCHRONISED_LAST_HOUR') &&
                            <FormControlLabel
                                sx={{ mb: 2 }}
                                control={<Checkbox checked={isChecked(schedule)} onChange={(_, checked) => {
                                    updateState(i, 'day_of_week', checked ? weekDays.map(e => e.value) : [])
                                }} size='small' />}
                                label={<Typography
                                    variant='body2'>{t('configuration:everyDay')}</Typography>}></FormControlLabel>
                        }
                    </>
                ))}

            </Stack>

            {
                !isTriggerMoreShown() && <Box mt={2}>
                    <Button onClick={() => addNewSchedule(currentType)}
                        variant='outlined'>{t('configuration:addMoreTriggers')}</Button>
                </Box>
            }


        </Box>
    )
}

export default Schedules